import React, { Component } from 'react'
import ReactPaginate from 'react-paginate'
import Dropdown from '../components/Dropdown'
import Pill from '../components/Pill'
import Loader from '../components/Loader'
import InlineLoader from '../components/InlineLoader'
import { LanguageContext, LanguageConsumer } from '../lib/LanguageContext'
import Severity from '../components/Severity'
import Filters from './Filters'
import Error from '../components/Error'
import NotAuthorized from '../components/NotAuthorized'
import Footer from '../Footer'
import { Link } from 'react-router-dom'
import moment from 'moment'
import * as queryString from 'query-string'
import * as apiCalls from '../lib/apiCalls'
import './Checks.css'


const helperFields = ['enrollmentStatusDateJoined', 'enrollmentStatusDateFromJoined', 'enrollmentStatusDateToJoined', 'birthDateJoined']
const fieldPairs = {'enrollmentStatusDate': 'enrollmentStatusDateJoined',
                    'enrollmentStatusDateFrom': 'enrollmentStatusDateFromJoined',
                    'enrollmentStatusDateTo': 'enrollmentStatusDateToJoined',
                    'birthDate': 'birthDateJoined'}

class Checks extends Component {

    constructor(props) {
        super(props)
        this.state = {
            debug: false,
            error: false,
            notAuthorized: false,
            studentSearchOpen: false,
            filtersModalIsOpen: false,
            sortSelectorActive: false,
            redirectToRecord: false,
            enrollmentTypeActive: false,
            enrollmentStatusActive: false,
            transition: true,
            generalFetched: false,
            resultsFetched: false,
            resultsFileExistsFetched: false,
            generalLoading: 0,
            resultsLoading: 0,
            resultsFileExistsLoading: 0,
            resultsFileExists: false,
            resultsFilename: '',
            updateOnce: false,
            filterToEdit: {
                name: '',
                selector: false
            },
            table: {
                maxRows: 12,
                currentStart: 0,
                currentEnd: 0,
                pageCount: 0,
                currentPage: 0
            },
            sortingActive: {
                id: 'registrationID-lh',
                order: 'lh',
                property: 'registrationID'
            },
            departments: [],
            sortingList: [],
            severityGroupList: [],
            errorList: [],
            filters: {
                enrollmentStatusDateType: 'period',
                enrollmentTermType: 'period',
                fields: {
                    registrationID: '',
                    systemID: '',
                    ssn: '',
                    ssnCountry: '',
                    tin: '',
                    tinCountry: '',
                    lastNameEl: '',
                    lastNameEn: '',
                    firstNameEl: '',
                    firstNameEn: '',
                    fatherFirstNameEl: '',
                    fatherFirstNameEn: '',
                    motherFirstNameEl: '',
                    motherFirstNameEn: '',
                    departmentID: '',
                    severityGroup: '',
                    enrollmentTerm: '',
                    enrollmentTermFrom: '',
                    enrollmentTermTo: '',
                    enrollmentType: '',
                    enrollmentStatus: '',
                    enrollmentStatusDate: '',
                    enrollmentStatusDateJoined: '',
                    enrollmentStatusDateFrom: '',
                    enrollmentStatusDateFromJoined: '',
                    enrollmentStatusDateTo: '',
                    enrollmentStatusDateToJoined: '',
                    birthDate: '',
                    birthDateJoined: '',
                    birthYear: '',
                    gender: '',
                    citizenship: '',
                    accountStatus: '',
                    loginName: '',
                    extEmail: '',
                    mobilePhone: ''
                },
                selections: [{
                    id: 'fields',
                    selected: [],
                    availableSelections: [],
                    queryStr: 'all',
                    active: false
                 },{
                    id: 'errorTypes',
                    selected: [],
                    availableSelections: [],
                     queryStr: 'all',
                     active: false
                 }, {
                    id: 'errorCodes',
                    selected: [],
                    availableSelections: [],
                    queryStr: 'all',
                    active: false
                 }],
            },
           queryStr: '',
           generalResults: {},
           rows: [], 
        }
    }  

    handlePageClick = async (data) => {
        let table = this.state.table
        table.currentStart = data.selected
        this.setState({
            table
        } , () => {
            this.setQueryStr()
            this.updateComponent(data.selected)
        })
    }

    sortSelectorToggle = () => {
        this.props.handleDropdown(!this.state.sortSelectorActive)
        this.setState(prevState => ({
            ...prevState,
            sortSelectorActive: !prevState.sortSelectorActive
        })) 
    }

    sortSelectorClose = () => {
        this.props.handleDropdown(false)
        this.setState(prevState => ({
            ...prevState,
            sortSelectorActive: false
        })) 
    }
    
    openFiltersModal = () => {
        this.setState({filtersModalIsOpen: true})
        this.props.handleModal(true)
    }

    closeFiltersModal = () => {
        let filterToEdit = this.state.filterToEdit
        this.setState({filtersModalIsOpen: false})
        this.props.handleModal(false)
        filterToEdit = {...filterToEdit, name: '', selector: false}
        this.setState({filterToEdit})
    }

    sortingHandleChange = (active) => {
        this.setState(prevState => ({
            ...prevState,
            sortingActive: active,
        }), () => {
            this.setQueryStr()
            this.updateComponent(0)
        })
        setTimeout(() => {
            this.setState(prevState => ({
                ...prevState,
                sortSelectorActive: false
            }))
            this.props.handleDropdown(false)
        }, 500) 
    } 

    setQueryStr = () => {
        let queryStr = '/results?'
        let fields = this.state.filters.fields
        let selections = this.state.filters.selections
        Object.keys(fields).filter(key => !helperFields.includes(key)).map(key => {
            if(fields[key]) {
                queryStr += `${key}=${fields[key]}&`
            }
        })
        selections.map(sel => {
            if(sel.queryStr.length) {
                queryStr += `${sel.id}=${sel.queryStr}&`
            }
        })
        queryStr += `sort=${this.state.sortingActive.id}&`
        queryStr += `page=${this.state.table.currentStart}&`
        if(queryStr[queryStr.length - 1] === '&') {
            queryStr = queryStr.slice(0, -1)
        }
        this.props.history.push(queryStr)
        this.setState({queryStr})
    }

    setFilters = (filters) => {
        this.setState({filters}, () => this.setQueryStr())
    }

    clearFilters = () => {
        let selections = this.state.filters.selections.map(sel => { return {...sel, selected: [], queryStr: ['']} })
        let fields = this.state.filters.fields
        Object.keys(fields).map(l => fields[l] = '')
        let filters
        filters = {...filters, fields,
                      selections, enrollmentStatusDateType: 'period',
                      enrollmentTermType: 'period' }
        this.setState({filters})
        this.props.history.push(`/results`)
    }

    cancelFieldFilter = (name) => {
        let filters = this.state.filters
        let fields = filters.fields
        fields[name] = ''
        if(name in fieldPairs) {
            fields[fieldPairs[name]] = ''
        } 
        filters = {...filters, fields}
        this.setState({filters}, () => this.setQueryStr())
    }

    cancelSelectionFilter = (name, value) => {
        let filters = this.state.filters
        let selections = filters.selections
        let selectionIndex = selections.findIndex(sel => sel.id === name)
        let selection = selections[selectionIndex]
        let availableSelections = selection.availableSelections
        selection.selected = selection.selected.filter(val => val !== value)
        let selectedLen = selection.selected.length
        if(selectedLen === 0) {
            selection.selected = []
        }
        selection.queryStr = ''
        if(selection.selected.length === availableSelections.length) {
            selection.queryStr = 'all'
        } else {
            selection.selected.map(sel => {
                selection.queryStr += `${sel},`
            })
        }
        selections[selectionIndex] = {...selection}
        filters = {...filters, ...selections}
        this.setState({filters}, () => this.setQueryStr())
    }

    editFieldFilter = (name, selector) => {
        let filterToEdit = this.state.filterToEdit
        filterToEdit = {...filterToEdit, name, selector}
        this.setState({
            filterToEdit
        },() => this.openFiltersModal())
    }

    dataFetched(res) {
        if(res === 403) {
            this.setState({notAuthorized: true})
        } else if(res === 500 || 'error' in res) {
            this.setState({error: true})
        } else {
            return true
        }
        return false
    }

    updateComponent = async (currentPage) => {
        let filters = this.state.filters
        let activeResults = 0
        let currentEnd
        let pageCount
        let rows = []
        let res

        let resultsLoading = this.state.resultsLoading - 1
        this.setState({resultsLoading})
        res = await this.fetchResults(filters, currentPage)
        if(this.dataFetched(res)) {

            activeResults = res.numOfFilteredResults
            currentEnd = activeResults >= this.state.table.maxRows ? this.state.table.maxRows : activeResults
            pageCount = Math.floor(activeResults / this.state.table.maxRows)
            pageCount = activeResults % this.state.table.maxRows ? (pageCount + 1) : pageCount
            rows = this.state.rows
            if(res.results) {
                rows = res.results
            }
            this.setState(prevState => ({
                ...prevState,
                updatedOnce: true,
                generalResults: {
                    ...prevState.generalResults,
                    filteredResults: activeResults
                },
                table : {
                    ...prevState.table,
                    currentPage,
                    currentEnd: currentEnd,
                    pageCount
                },
                resultsFetched: true,
                resultsLoading: resultsLoading + 1,
                rows
            }))
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.updatedOnce && this.state.filters !== prevState.filters) {
               this.updateComponent(0)
           }
    }
    
    selectionInit(arr, selections, category, availableSelections, explanation){
        arr = arr.split(',').filter(r => r.length > 0)
        if(availableSelections.findIndex(sel => sel.id === 'all') < 0) {
          availableSelections.unshift({'id': 'all'})
        }
        availableSelections = availableSelections.map(sel => {
            return {...sel, 
                      display: this.context.polyglot.t(`Dropdown.${category.id}.${sel.id}`),
                      explanation: explanation && sel.id !== 'all' ? this.context.polyglot.t(`Dropdown.${category.id}.explanations.${sel.id}`) : ''
                }})
        let selected = []
        let queryStr = arr
        if(arr.length !== 0 && arr[0] !== 'all') {
            selected = availableSelections.filter(selection => arr.indexOf((selection.id).toString()) > -1)
                                          .map(selection => selection.id)
        }
        let categoryIndex = selections.findIndex(sel => sel.id === category.id)
        selections[categoryIndex] = {...selections[categoryIndex],
            selected,
            queryStr,
            availableSelections
        }
        return selections
    }

    filterSelectionsInit = (test, filters) => {
        let selections = filters.selections
        let fieldsCategory = this.state.filters.selections.find(sel => sel.id === 'fields')
        let errorTypeCategory = this.state.filters.selections.find(sel => sel.id === 'errorTypes')
        let errorCodeCategory = this.state.filters.selections.find(sel => sel.id === 'errorCodes')
        test.fields = !('fields' in test) ? 'all' : test.fields
        test.errortypes = !('errorTypes' in test) ? 'all' : test.errorTypes
        test.errorcodes = !('errorCodes' in test) ? 'all' : test.errorCodes
        this.selectionInit(test.fields, selections, fieldsCategory, this.props.fieldSelection, true)
        this.selectionInit(test.errortypes, selections, errorTypeCategory, this.props.errorTypeSelection, false)
        this.selectionInit(test.errorcodes, selections, errorCodeCategory, this.props.errorCodeSelection, false)
        filters = {...filters, selections}
    }

    fieldsSelectionsInit = (test, filters) => {
        let fields = filters.fields
        Object.keys(test).map(key => {
            if(key in fields) {
                fields[key] = test[key]
                if(key in fieldPairs) {
                    fields[fieldPairs[key]] = test[key].replace(/-/g, '')
                }
            }
        })
        let enrollmentStatusDateType = fields['enrollmentStatusDate']  ? 'single' : 'period'
        let enrollmentTermType = fields['enrollmentTermType'] ? 'single' : 'period'
        filters = {...filters, 
                   fields, 
                   enrollmentStatusDateType, 
                   enrollmentTermType}
    }

    sortingInit = (test, sortingActive) => {
        let newSortingActive = {}
        if('sort' in test) {
            newSortingActive = this.props.sortingSelection.find(sel => sel.id === test['sort'])
        } else {
            newSortingActive = this.props.sortingSelection[0]
        }
        sortingActive.id = newSortingActive.id
        sortingActive.order = newSortingActive.order
        sortingActive.property = newSortingActive.property
    }

    pageInit = (test, table) => {
        let currentPage = 0
        if('page' in test) {
           currentPage = Number(test['page'])
        }
        table.currentPage = currentPage
    }

    fetchResultsFileExists = async () => {
        return await apiCalls.reportExists(this.props.institutionId, this.props.runType)
    }

    fetchDepartments = async () => {
         return await apiCalls.getInstitutionDepartments(this.props.institutionId, this.props.runType)
    }

    fetchGeneral = async () => {
         return await apiCalls.resultsGeneral(this.props.runType)
    }

    fetchResults = async (filters, page) => {
        let body = {}
        let fields = filters.fields
        let sorting = this.state.sortingActive
        body.institutionName = this.props.institutionId
        body.runType = this.props.runType
        body.offset = page * this.state.table.maxRows
        body.length = this.state.table.maxRows
        body.filters = {}
        body.sorting = {}
        
        Object.keys(fields).filter(key => !helperFields.includes(key))
                            .map(key => {
                                   if(fields[key].toString().length) {
                                        if(fieldPairs.hasOwnProperty(key)) {
                                            body.filters[key] = fields[fieldPairs[key]]
                                        } else {  
                                            body.filters[key] = fields[key]
                                        }
                                    }
                            })
        filters.selections.map(sel => {
            if(sel.selected.length !== 0 && sel.selected.length !== sel.availableSelections.length) {
                body.filters[sel.id] = sel.selected
            }
        })
        body.sorting.property = sorting.property
        body.sorting.order = sorting.order === 'lh' ? 'ascending' : 'descending'
        body.institutionName = this.props.institutionId
        return await apiCalls.recordsWithErrors(body)
    }

    resultsFileExistsInit = async() => {
        let resultsFileExists
        let resultsFilename
        let resultsFileLoading = this.state.resultsFileLoading - 1
        this.setState({resultsFileLoading})
        let res = await this.fetchResultsFileExists()

        if(this.dataFetched(res)) {

            resultsFileExists = res.exists
            resultsFilename = res.filename

            this.setState({
                resultsFileExists,
                resultsFileFetched: true,
                resultsFileLoading: resultsFileLoading + 1,
                resultsFilename: `/v-vd-checks/report/${res.fileName}`
            })
        }
    }

    generalResultsInit = async() => {
        let generalResults
        let generalLoading = this.state.generalLoading - 1
        this.setState({generalLoading})
        let res = await this.fetchGeneral()

        if(this.dataFetched(res)) {

            generalResults = res
            let dateOfRun = generalResults.dateOfRun
            let localDate = moment(dateOfRun)
            let locale = this.context.polyglot.currentLocale
            localDate.locale(locale)
            dateOfRun = localDate.format('llll')
            generalResults = {...generalResults, dateOfRun}

            this.setState({
                generalResults,
                generalFetched: true,
                generalLoading: generalLoading + 1
            })
        }
    }

    specificResultsInit = () => {
        let filters = this.state.filters
        let sortingActive = this.state.sortingActive
        let queryStr = this.props.history.location.search
        let table = this.state.table
        let test = queryString.parse(queryStr)
        let severityGroupList = this.props.severitySelection
        if(!severityGroupList.find(sel => sel.id == 'all')) {
            severityGroupList.unshift({id: 'all'})
        }
        severityGroupList = severityGroupList.map(sel => {return {...sel, display: this.context.polyglot.t(`Dropdown.severityGroup.${sel.id}`)}})

        let sortingList = this.props.sortingSelection.map(sel => {return {...sel, display: this.context.polyglot.t(`Dropdown.sortingRecords.${sel.id}`)}})
        this.fieldsSelectionsInit(test, filters)
        this.filterSelectionsInit(test, filters)
        this.sortingInit(test, sortingActive)
        this.pageInit(test, table)
        filters = {...filters}
        this.setState({
            filters,
            sortingActive,
            severityGroupList,
            sortingList
        }, () => this.updateComponent(table.currentPage))
    }

    dateFormating = () => {

    }

    componentDidMount = async() => {
        document.title = this.context.polyglot.t('resultsPageTitle')
        let content = document.getElementById('content')
        content.scrollTop = 0
        setTimeout(() => {
            this.setState(prevState => ({
                ...prevState,
                transition: false
            }))
        }, 10)

        let departments = await this.fetchDepartments()
        if(this.dataFetched(departments)) {
            departments = departments.departmentIds.map(dep => {return {...dep, display: dep.nameEl}})
            let allDepSelection = {id: 'all', nameEl: 'Ολα τα Τμήματα', nameEn: 'All Departments', display: 'Όλα τα Τμήματα'}
            departments.unshift(allDepSelection)
            this.setState({departments: departments})
            this.specificResultsInit()
            this.generalResultsInit()
            this.resultsFileExistsInit()
        }
    }

    prepareFieldTranslations = (fields) => {
        let translatedFields = {...fields}
        if(this.state.departments) {
            let depId = fields.departmentID
            let department = this.state.departments.find(dep => dep.id === depId)
            if(department) {
                let depDisplay = department.display
                translatedFields = {...fields, departmentID: depDisplay}
            }
        }
        let severityGroup = fields.severityGroup
        if(severityGroup) {
            translatedFields = {...translatedFields, severityGroup: this.context.polyglot.t(`Pills.selections.severityGroups.${severityGroup}`)}
        }
        return translatedFields
    }

    render () {

        let rows =  this.state.rows
        let filterFields = this.state.filters.fields
        let filterSelections = this.state.filters.selections
        let departmentSelection = []

        let transFilterFields = this.prepareFieldTranslations(filterFields)

        if(this.state.error) {
            return (<Error/>)
        } else if (this.state.notAuthorized) {
            return (<NotAuthorized handleLogout={this.props.handleLogout} 
                                   location={this.props.history.location.pathname}
                                   queryString={this.props.history.location.search}/>)
        }

        return(
            <LanguageConsumer>
            {({polyglot}) =>
                (<div className={`Checks ${this.state.transition ? 'transition' : ''}`}>
                        <div className='header-info'>
                            <h2 className='checks-header'><span className="fas fa-check"></span> {polyglot.t('Checks.checksResults')}</h2>

                            <div className='info-entity'>
                                <span className="fa fa-calendar-check"></span> {polyglot.t('lastRun')}:
                                {this.state.generalFetched && 
                                 this.state.generalLoading === 0 ? (
                                    <span className='errText-value'>{this.state.generalResults.dateOfRun}</span>
                                ) : (
                                    <InlineLoader/>
                                )
                                }
                            </div>
                            <div className='info-entity'>
                                <span className="fas fa-users"></span> {polyglot.t('numberOfRecordsChecked')}:
                                {this.state.generalFetched && 
                                 this.state.generalLoading === 0 ? (
                                    <span className='info-value'>{this.state.generalResults.totalRecordsCount}</span>
                                ) : (
                                    <InlineLoader/>
                                )
                                }
                            </div>
                            <div className='info-entity'>
                                <span className="fas fa-user-times"></span> {polyglot.t('Checks.numOfRecordsWErrors')}:
                                {this.state.generalFetched && 
                                 this.state.generalLoading === 0 ? (
                                    <span className='info-value'>{this.state.generalResults.faultyRecordsCount}</span>
                                ) : (
                                    <InlineLoader/>
                                )
                                }
                            </div>
                            <div className='info-entity'>
                                <span className="fas fa-exclamation-triangle"></span> {polyglot.t('Checks.numOfErrors')}:
                                {this.state.generalFetched &&
                                 this.state.generalLoading === 0 ? (
                                    <span className='info-value'>{this.state.generalResults.numberOfErrors}</span>
                                ) : (
                                    <InlineLoader/>
                                )
                                }
                            </div>
                            <div className='info-entity' id='where-clause'>
                                <span className="fas fa-filter"></span> {polyglot.t('databaseFilter')}: 
                                {this.state.generalFetched && 
                                 this.state.generalLoading === 0 ? (
                                   <span className='errText-value'>
                                       <i>{this.state.generalResults.whereClause}</i>
                                   </span>
                                 ) : (
                                     <InlineLoader/>
                                 )
                                 }
                             </div>

                            <span id='download-file'>
                                {this.state.resultsFileFetched &&
                                 this.state.generalLoading === 0 ? (
                                    this.state.resultsFileExists ? (
                                        <a href={this.state.resultsFilename} target='_blank' rel="noopener noreferrer">
                                           <button>{polyglot.t('Checks.downloadResultsFile')} <span className='fas fa-file'></span></button>
                                       </a>
                                    ) : (
                                        <button className='tooltip' disabled data-tooltip={polyglot.t('Checks.noResultsFileAvailable')}>{polyglot.t('Checks.downloadResultsFile')} <span className='fas fa-file'></span></button>
                                    )
                                 ) : (
                                      <InlineLoader/>
                                  )
                                }
                            </span>
                    </div>
                <div className='results'>
                    <div className='table-wrapper'>
                        <h3 className='results-header'><span className='fas fa-exclamation-triangle'></span> {polyglot.t('Checks.recordsWErrors')}</h3>
                        <div className='filters-wrapper'>
                            <div className='pills'>
                                {Object.keys(filterFields).filter(field => filterFields[field].toString().length && 
                                                                           !helperFields.includes(field) 
                                                                  ).map(field => {
                                    return <Pill key={`${field}_${filterFields[field]}`}
                                                 name={field} label={polyglot.t(`Pills.fields.${field}`)}
                                                 value={transFilterFields[field]} 
                                                 labelShow
                                                 onClose={this.cancelFieldFilter}
                                                 onEdit={this.editFieldFilter}/>
                                })}
                                {filterSelections.filter(selection => selection.selected.length !== selection.availableSelections.length)
                                                  .map(selection =>
                                                      selection.selected.filter(value => value !== 'all').map(value => {
                                            return (

                                                <Pill key={`${selection.id}_${value}`}
                                                      name={selection.id}
                                                      label={selection.id}
                                                      value={value}
                                                      display={polyglot.t(`Pills.selections.${selection.id}.${value}`)}
                                                      onClose={this.cancelSelectionFilter}
                                                      onEdit={this.editFieldFilter}
                                                      translated/>
                                        )}
                                    )
                                )}
                            </div>
                            <div className='Checks-filter'>
                                <Filters filtersModalIsOpen={this.state.filtersModalIsOpen}
                                         onRequestClose={this.closeFiltersModal}
                                         fieldPairs={fieldPairs}
                                         filters={this.state.filters}
                                         setFilters={this.setFilters}
                                         departmentList={this.state.departments}
                                         severityGroupList={this.state.severityGroupList}
                                         errorList={this.state.errorList}
                                         enrollmentTypeList={this.props.enrollmentType}
                                         enrollmentStatusList={this.props.enrollmentStatus}
                                         accountStatusList={this.props.accountStatus}
                                         handleDropdown={this.props.handleDropdown}
                                         fieldToEdit={this.state.filterToEdit}/>
                                <button id='more-filters' onClick={this.openFiltersModal}><span className='fas fa-sliders-h'></span> {polyglot.t('Checks.filters')}</button>
                                <div className='clearFiltersWrapper'>
                                    <span className='clear-filters' onClick={this.clearFilters}>
                                        {polyglot.t('Checks.clear')} <span className="fas fa-broom"></span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <hr></hr>
                        <div className='table-info-wrapper'>
                            <span className='filtered-results'>
                                <h5 className='checks-header'>{polyglot.t('Checks.numOfFilteredResults')}</h5>: <span className='info-value'>{this.state.generalResults.filteredResults}</span>
                            </span>
                            <div className='sorting'>
                                    <span className='sort-header'>
                                        {polyglot.t('Record.sortBy')}:
                                    </span>
                                    <Dropdown className='flexible'
                                            name='sorting-records'
                                            handleChange={this.sortingHandleChange}
                                            type='single-select'
                                            list={this.state.sortingList}
                                            withIcon={true}
                                            active={this.state.sortSelectorActive} toggle={this.sortSelectorToggle}
                                            close={this.sortSelectorClose}
                                            activeId={this.state.sortingActive.id}
                                            selection={polyglot.t(`Dropdown.sortingRecords.label`)}
                                            translate
                                    />
                            </div>
                        </div>
                        <div className='h-scroll'>
                        <table className='results-table' cellPadding="0" cellSpacing="0">
                            <thead>
                                <tr>
                                    <th>
                                        {polyglot.t('Checks.registrationId')}
                                    </th>
                                    <th>
                                        {polyglot.t('Checks.systemId')}
                                    </th>
                                    <th>
                                        {polyglot.t('Checks.department')}
                                    </th>
                                    {
                                        this.state.debug &&
                                        <th>
                                            {polyglot.t('Checks.errorType')}
                                        </th>
                                    }
                                    {
                                        this.state.debug &&
                                        <th>
                                            {polyglot.t('Checks.field')}
                                        </th>
                                    }
                                    <th>
                                        {polyglot.t('Checks.severity')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                { rows && 
                                  this.state.resultsFetched &&
                                  this.state.resultsLoading === 0 ? (
                                     rows.length > 0 ?
                                            rows
                                            .map((r,i) => 
                                                <tr className='content-row' key={i} >
                                                        <td className='first-td'>
                                                           <Link to={{
                                                                pathname: `results/${r.objectID}`,
                                                               parentQueryStr: this.props.location.search

                                                                }}
                                                            >
                                                                {r.registrationID}
                                                            </Link> 
                                                        </td>
                                                        <td>
                                                            <Link to={{
                                                                pathname: `results/${r.objectID}`,
                                                                parentQueryStr: this.props.location.search
                                                                }}
                                                            >
                                                                {r.systemID}
                                                            </Link>
                                                        </td>
                                                        <td>
                                                            <Link to={{
                                                                pathname: `results/${r.objectID}`,
                                                                parentQueryStr: this.props.location.search
                                                                }}
                                                            >
                                                                {r.departmentEl}
                                                            </Link>
                                                        </td>
                                                        <td>
                                                            <Link to={{
                                                                pathname: `results/${r.objectID}`,
                                                                parentQueryStr: this.props.location.search
                                                                }}
                                                            >
                                                                <Severity classId={r.severity} displayString/>
                                                            </Link>
                                                        </td>
                                                </tr>
                                            )
                                        : (
                                            <tr>
                                                <td colSpan="6" className='no-res'>{polyglot.t('noMatchingResults')}</td>
                                            </tr>
                                        )
                                    )
                                    : (
                                       <tr>
                                           <td colSpan="6">
                                               <Loader/>
                                           </td>
                                       </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        </div>
                    </div>
                    <div className='pagination-wrapper'>
                        {this.state.resultsFetched &&
                         this.state.resultsLoading === 0 && (
                            <ReactPaginate previousLabel={"\u3008"}
                                    nextLabel={"\u3009"}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    forcePage= {this.state.table.currentPage}
                                    pageCount={this.state.table.pageCount}
                                    marginPagesDisplayed={this.props.mobile ? 1  : 2}
                                    pageRangeDisplayed={this.props.mobile ? 1 : 3}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={"pagination"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"} />
                         )
                        }
                       </div>
                    </div>
                    <Footer/>
                </div>)}
             </LanguageConsumer>
        )
    }
}
Checks.contextType = LanguageContext

export default Checks



// WEBPACK FOOTER //
// ./src/results/Checks.js